module.exports = __webpack_public_path__ + "img/img1.a8ae045c.png";